import { Text } from '@workos-inc/design-system';
import classNames from 'classnames';
interface TimelineRootProps extends React.ComponentPropsWithoutRef<'div'> {
  top?: number;
}
const TimelineRoot = ({
  top = 0,
  className,
  style,
  ...props
}: TimelineRootProps) => <div className={classNames('TimelineRoot', className)}
// Introducing lint rule banning type assertions
// Type assertion is here to workaround --timeline-top being unknown property
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
style={{
  '--timeline-top': `${top}px`,
  ...style
} as Record<string, string>} {...props} data-sentry-component="TimelineRoot" data-sentry-source-file="timeline.tsx" />;
interface TimelinePointProps extends React.ComponentPropsWithoutRef<'div'> {
  latest?: boolean;
  className?: string;
  children?: React.ReactNode;
}
const TimelinePoint = ({
  latest,
  className,
  children,
  ...props
}: TimelinePointProps) => <div className={classNames('TimelinePoint', className, {
  latest
})} {...props} data-sentry-component="TimelinePoint" data-sentry-source-file="timeline.tsx">
    <Text className="TimelinePointText" color={latest ? 'green' : 'gray'} size="2" data-sentry-element="Text" data-sentry-source-file="timeline.tsx">
      {children}
    </Text>
    <div className="TimelinePointDot" />
  </div>;
const TimelineTrack = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => <div className={classNames('TimelineTrack', className)} {...props} data-sentry-component="TimelineTrack" data-sentry-source-file="timeline.tsx">
    <div className="TimelineTrackStart" />
    <div className="TimelineTrackCenter" />
    <div className="TimelineTrackEnd" />
  </div>;
export const Timeline = {
  Root: TimelineRoot,
  Track: TimelineTrack,
  Point: TimelinePoint
};